import React, { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getFaqs } from '../../../ducks/strapi.duck';
import { STRAPI_USER_TYPE } from '../../../util/enums';
import css from '../FaqPage.module.css';
import { convertMarkdownToReact } from '../../../util/markdownHelpers';

const FaqSection = () => {
  const intl = useIntl();
  const [selectedTab, setSelectedTab] = useState(STRAPI_USER_TYPE.CUSTOMER);

  const faqsData = useSelector(getFaqs);

  const handleTabChange = (_, newValue) => {
    setSelectedTab(newValue);
  };

  const filteredFaqs =
    faqsData?.filter(faq => faq.type && faq.type.toLowerCase() === selectedTab) || faqsData;

  return (
    <>
      <div className={css.tabContainer}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          centered
          textColor="primary"
          indicatorColor="primary"
          className={css.customTabs}
          classes={{ indicator: css.redIndicator }}
        >
          <Tab
            label={intl.formatMessage({ id: 'FaqPage.customerTab' })}
            value={STRAPI_USER_TYPE.CUSTOMER}
            className={selectedTab === STRAPI_USER_TYPE.CUSTOMER ? css.activeTab : css.tab}
          />
          <Tab
            label={intl.formatMessage({ id: 'FaqPage.providerTab' })}
            value={STRAPI_USER_TYPE.SUPPLIER}
            className={selectedTab === STRAPI_USER_TYPE.SUPPLIER ? css.activeTab : css.tab}
          />
        </Tabs>
      </div>

      {/* FAQs Section */}
      <div className={css.wrapper}>
        {filteredFaqs.map((faq, index) => (
          <Accordion key={faq.id || index} className={css.faqCard}>
            <AccordionSummary
              className={css.faqHeading}
              expandIconWrapper={css.faqIcon}
              expanded={css.faqExplanded}
              expandIcon={<ArrowDropDownIcon />}
              aria-controls={`panel-${index}-content`}
              id={`panel-${index}-header`}
            >
              <Typography style={{ padding: 0, margin: 0 }}>
                <div className={css.question}>{faq.question}</div>
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={css.faqDescription}>
              <Typography component="div">
                <div className={css.answers}>
                  {faq.answer ? convertMarkdownToReact(faq.answer) : null}
                </div>
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </>
  );
};

export default FaqSection;
